import { useEffect, useRef, useState } from "react";
import { STORES, type Store } from "@shared/stores";

const STORAGE_KEY = "smartrx-entry.currentStoreCode";

function getInitialStore(): Store {
  if (typeof window !== "undefined") {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    const found = STORES.find((s) => s.code === saved);
    if (found) return found;
  }
  return STORES.find((s) => s.code === "GV") ?? STORES[0]!;
}

export function LocationSwitcher() {
  const [current, setCurrent] = useState<Store>(getInitialStore);
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, current.code);
  }, [current]);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    window.addEventListener("mousedown", onClick);
    return () => window.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 px-3 py-1 bg-accent-soft text-accent rounded text-sm font-semibold hover:ring-1 hover:ring-accent"
      >
        {current.city} · {current.code}
        <span className="text-[10px] opacity-70">▼</span>
      </button>
      {open && (
        <div className="absolute right-0 top-9 w-72 bg-surface border border-border rounded-md shadow-lg py-2 z-50">
          {STORES.map((s) => (
            <button
              key={s.code}
              type="button"
              onClick={() => {
                setCurrent(s);
                setOpen(false);
              }}
              className={`w-full flex items-center justify-between px-4 py-2 hover:bg-accent-soft ${
                s.code === current.code ? "bg-accent-soft" : ""
              }`}
            >
              <span className="font-semibold text-sm">{s.city}</span>
              <span className="text-xs bg-pill text-ink-soft px-1.5 py-0.5 rounded">{s.code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
